export function latestNewsSlider() {
    const $slider = $(".latest-news-slider");

    $slider.not(".slick-initialized").slick({
        dots: true,
        arrows: false,
        infinite: false,
        draggable: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 2.05,
                    slidesToScroll: 2
                }
            },
            {

                breakpoint: 767,
                settings: {
                    slidesToShow: 2.25,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2

                }
            },
            {

                breakpoint: 1799,
                settings: {
                    slidesToShow: 3.65,
                    slidesToScroll: 3,
                }
            }
        ]
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/latestNewsSlider.js